import { regularizationActionTypes } from './Regularization.actionTypes';

const initialState = {
  requests: [],
  managerRequests: [],
  loading: false,
  error: null,
  success: false,
};

const regularizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case regularizationActionTypes.SET_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default regularizationReducer;
